import { Capacitor } from '@capacitor/core';
import { toastController } from '@ionic/vue';

/** In-app toast for replay status (works on native and web). */
export async function showReplayToast(message: string): Promise<void> {
  const toast = await toastController.create({ message, duration: 3000 });
  await toast.present();
}

/** Notify the user that a replay is ready (toast on native; web notification when permitted). */
export async function showReplayReadyAlert(flightName: string): Promise<void> {
  const label = flightName || 'Flight';
  if (Capacitor.isNativePlatform()) {
    await showReplayToast(`Replay ready: ${label}`);
    return;
  }

  await showReplayToast(`Replay ready to download: ${label}`);

  if (typeof Notification === 'undefined') return;
  if (Notification.permission === 'granted') {
    new Notification('Flight Track', {
      body: `Replay ready: ${label}`,
      tag: 'replay-ready',
    });
  } else if (Notification.permission === 'default') {
    Notification.requestPermission().then((p) => {
      if (p === 'granted') {
        new Notification('Flight Track', {
          body: `Replay ready: ${label}`,
          tag: 'replay-ready',
        });
      }
    });
  }
}

/** Shown when client polling timed out but server generation may still be running. */
export async function showReplayStillGeneratingAlert(): Promise<void> {
  await showReplayToast("Replay still generating — we'll notify you when it's ready.");
}
